export const FontVariant = {
  PrimaryBold: "Primary-Bold",
  PrimaryRegular: "Primary-Regular",
  PrimaryThin: "Primary-Thin",
  SecondaryBold: "Secondary-Bold",
  SecondaryRegular: "Secondary-Regular",
  SecondaryThin: "Secondary-Thin",
};
